<!--suppress JSUnresolvedReference -->
@if (luser | async; as user) {
  <div class="user-menu mx-2">
    <div
      tuiDropdownOpen
      [tuiDropdown]="umenu"
      class="d-flex align-items-center">
      @if (user.company?.name) {
        <div class="company-info me-2">
          <span class="company-name">{{ user.company.name }}</span>
          @if (user.company.accountExpiresAt) {
            <span class="expiration-info ms-2">
              @if (user.company.isDemo) {
                <span class="text-muted">(Demo)</span>
              }
              <span class="expiration-date ms-1 text-muted">
                Valid until
                {{ formatExpirationDate(user.company.accountExpiresAt) }}
              </span>
            </span>
          }
        </div>
      }
      <tui-avatar
        [src]="
          user.avatar ||
          (user.lastname ? (user.lastname | tuiInitials) : '') ||
          '@tui.user'
        "
        [round]="true"
        class="avatar-btn"
        size="m"
        appearance="secondary"></tui-avatar>
    </div>
  </div>

  <ng-template #umenu>
    <tui-data-list role="menu" class="user-menu">
      <tui-opt-group>
        <a tuiOption class="profile-option" routerLink="/users/profile">
          <div class="d-flex align-items-center">
            <tui-avatar
              [src]="
                user.avatar ||
                (user.firstname || user.lastname
                  ? (user.firstname + ' ' + user.lastname | tuiInitials)
                  : undefined) ||
                '@tui.user'
              "
              [round]="true"
              size="xl"
              appearance="secondary"></tui-avatar>
            <div class="profile-info mx-3">
              <div class="profile-name">
                @if (user.lastname || user.firstname) {
                  {{ user.lastname }} {{ user.firstname }}
                } @else {
                  {{ user.email }}
                }
              </div>
              <div class="profile-moto fw-light small" i18n>
                See your profile
              </div>
            </div>
          </div>
        </a>
      </tui-opt-group>
      <tui-opt-group>
        <a tuiOption class="m-option" (click)="logout()">
          <div class="d-flex align-items-center">
            <div class="m-option-icon">
              <tui-icon class="tm-icon" icon="@tui.log-out"></tui-icon>
            </div>
            <div class="m-option-text mx-3" i18n>Sign out</div>
          </div>
        </a>
      </tui-opt-group>
      <tui-opt-group>
        <div class="mini-links p-2 text-secondary my-mini-links">
          <a
            class="link-secondary"
            href="javascript:"
            i18n
            routerLink="/privacy-policy"
            >Privacy Policy</a
          >
          &nbsp; · &nbsp;
          <a
            class="link-secondary"
            href="javascript:"
            routerLink="/terms-of-service"
            i18n
            >Terms &amp; Conditions</a
          >
        </div>
      </tui-opt-group>
    </tui-data-list>
  </ng-template>
}
